import BaseChannelSerializer from '@square/dashboard-data/serializers/channels/base-channel-serializer';
export default class Count extends BaseChannelSerializer {
  modelNameFromPayloadKey() {
    return 'channels/platform-objects/count';
  }
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    const newPayload = payload;
    newPayload.counts.id = 1;
    return super.normalizeResponse(store, primaryModelClass, newPayload, id, requestType);
  }
}